const constants = require('../constants');

/* eslint-disable no-unused-vars */
function updateSearchAutocompleteSize(suggestionsWrapper, overlay) {
    const headerHeight = $('header').outerHeight();
    const siteSearchWrapper = $('.site-search-wrapper');
    const staticSuggestions = $('.static-content-suggestions');
    const staticSuggestionsHeight = staticSuggestions.length
        && staticSuggestions.is(':visible')
        && !siteSearchWrapper.length
        ? staticSuggestions.outerHeight() : 0;
    overlay.css('top', `${headerHeight}px`).fadeIn();
    staticSuggestions.css('top', `${headerHeight}px`);
    suggestionsWrapper.css('top', `${headerHeight - staticSuggestionsHeight}px`);
    suggestionsWrapper.css('height', `calc(100vh - ${headerHeight - staticSuggestionsHeight}px)`);
}

function showSearch() {
    const html = $('html');
    const docBody = $(document.body);
    const page = $('.page');
    const header = $('header > nav');
    const siteSearchWrapper = $('.site-search-wrapper');
    const siteSearch = $('.site-search');
    const suggestionsWrapper = $('.suggestions-wrapper');
    const staticSuggestions = $('.static-content-suggestions');
    const overlay = $('.site-search .overlay');
    const fakeSearch = $('.fake-input-placeholder');
    const isHomepage = $('#Home-Show').length;
    const searchNoPadding = $('.site-search-no-padding').length;
    const isDesktop = window.outerWidth >= constants.viewport_bootstrap.lg;

    $('.header-icons .icon-search-line, .header-icons .btn-search-toggle, .fake-input-placeholder').on('click', (e) => {
        const thisTarget = $(e.target);

        if($('.pdp-info-container').hasClass('expanded')){
            $('.pdp-info-container').removeClass('expanded');
        }

        if ($('.main-menu.menu-toggleable-left.in').length) {
            $('#menuMobileToggler').trigger('click');
        }

        if (thisTarget.hasClass('active')) {
            if (staticSuggestions.length) {
                staticSuggestions.fadeOut('fast');
                $('header').removeClass('search-active');
            }
            siteSearch.slideUp(() => {
                thisTarget.removeClass('active');
                page.removeClass('search-visible');
                overlay.fadeOut();
                docBody.css('padding-right', 0);
                if (isHomepage) {
                    header.css('padding-right', 0);
                }
                html.css('overflow', 'auto');
                if (fakeSearch.length) {
                    fakeSearch.removeClass('active');
                }
            });
        } else {
            if (staticSuggestions.length) {
                $('header').addClass('search-active');
                staticSuggestions.fadeIn('fast');
            }
            siteSearch.slideDown(() => {
                thisTarget.addClass('active');
                if (fakeSearch.length) {
                    fakeSearch.addClass('active');
                }
                html.css('overflow', 'hidden');
                if (isDesktop) {
                    docBody.css('padding-right', '8px');

                    if (isHomepage && searchNoPadding <= 0) {
                        header.css('padding-right', '8px');
                    }
                }
                document.getElementById('search-field').focus();
            });
        }
    });

    siteSearch.on('focusin', '#search-field', (e) => {
        const searchIcons = $('.search-focus');
        searchIcons.removeClass('d-none');
        if (!siteSearchWrapper.length && isDesktop) {
            docBody.css('padding-right', '8px');
        }
        if (isHomepage && !siteSearchWrapper.length && isDesktop && searchNoPadding <= 0) {
            header.css('padding-right', '8px');
        }
        if (staticSuggestions.length && siteSearchWrapper.length) {
            staticSuggestions.slideDown('fast');
        }
        page.addClass('search-visible');
        html.css('overflow', 'hidden');
        updateSearchAutocompleteSize(suggestionsWrapper, overlay);
        e.stopPropagation();
    });

    siteSearch.on('click', '.button-search-all', (e) => {
        e.preventDefault();
        const buttonSearch = $('.icon-search-line');
        buttonSearch.trigger('click');
        e.stopPropagation();
    });
}

function hideSiteSearch() {
    const html = $('html');
    const docBody = $(document.body);
    const page = $('.page');
    const header = $('header > nav');
    const siteSearch = $('.site-search');
    const fakeSearch = $('.fake-input-placeholder');
    const suggestionsWrapper = $('.suggestions-wrapper');
    const siteSearchWrapper = $('.site-search-wrapper');
    const staticSuggestions = $('.static-content-suggestions');

    if (siteSearch.hasClass('site-search-visible')) {
        const searchIcons = $('.search-focus');
        suggestionsWrapper.fadeOut('fast');
        searchIcons.addClass('d-none');
    } else {
        $('.icon-search-line').removeClass('active');
        suggestionsWrapper.fadeOut('fast', () => {
            siteSearch.slideUp();
        });
    }

    if (fakeSearch.length) {
        fakeSearch.removeClass('active');
    }

    if (siteSearchWrapper.length && staticSuggestions.length) {
        staticSuggestions.slideUp('fast');
    }

    siteSearch.find('.overlay').fadeOut('fast');
    siteSearch.find('#search-field').val('');
    page.removeClass('search-visible');
    html.css('overflow', 'auto');
    docBody.css('padding-right', 0);
    if ($('#Home-Show').length) {
        header.css('padding-right', 0);
    }
    $('header').removeClass('search-active');
}

function hideSearch() {
    $('.site-search .icon-cross-line').on('click', () => {
        hideSiteSearch();
    });

    $('.site-search .overlay').on('click', () => {
        hideSiteSearch();
    });
}

function updateSearchAutocomplete() {
    const suggestions = $('.suggestions');
    const suggestionsWrapper = $('.suggestions-wrapper');
    const page = $('.page');

    if (suggestions.length) {
        if (!page.hasClass('search-visible')) {
            const header = $('header').outerHeight();
            page.addClass('search-visible');

            suggestionsWrapper.css('max-height', `${$(window).height() - header}px`);
            suggestionsWrapper.slideDown();
        } else {
            suggestionsWrapper.slideDown();
        }
    } else {
        suggestionsWrapper.slideUp();
    }
}

function showSearchAutocomplete() {
    const suggestionsWrapper = document.querySelector('.suggestions-wrapper');
    const configSearch = { attributes: true, childList: true, subtree: true };

    if (suggestionsWrapper) {
        const callbackSearch = (mutationsListSearch, observerSearch) => {
            if (mutationsListSearch.some(mutation => $(mutation.target).hasClass('suggestions-wrapper'))) {
                mutationsListSearch.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        updateSearchAutocomplete();
                    });
                });
            }
        };

        const observerSearch = new MutationObserver(callbackSearch);
        observerSearch.observe(suggestionsWrapper, configSearch);
    }
}

module.exports = {
    showSearch,
    hideSearch,
    showSearchAutocomplete,
};
